import { createTypes } from "./createTypes";

export default createTypes(
  "USER_CONTACT_INFO_POST_STARTED",
  "USER_CONTACT_INFO_POST_SUCCESS",
  "USER_CONTACT_INFO_POST_FAILED"
);
